import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  static targets = ["permissionButton"]

  connect() {
    this.subscription = consumer.subscriptions.create("NotificationChannel", {
      received: (data) => this.showNotification(data)
    })
    // Hide the "Enable" button if browser permission is already resolved
    if (this.hasPermissionButtonTarget && typeof Notification !== "undefined") {
      this.permissionButtonTarget.hidden = Notification.permission !== "default"
    }
  }

  disconnect() {
    this.subscription?.unsubscribe()
  }

  // Triggered by button click in the preferences UI — user gesture required by browsers
  requestPermission() {
    if (typeof Notification === "undefined") return
    Notification.requestPermission().then((permission) => {
      if (this.hasPermissionButtonTarget) {
        this.permissionButtonTarget.hidden = permission !== "default"
      }
    })
  }

  showNotification(data) {
    if (window.__TAURI__?.core?.invoke) {
      // Tauri: show native macOS notification (macOS auto-prompts for permission on first call)
      window.__TAURI__.core.invoke("show_notification", { data })
    } else if (typeof Notification !== "undefined" && Notification.permission === "granted") {
      new Notification(data.title, { body: data.body })
    }
  }
}
